"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Toggler = void 0;
var _reactBurgers = require("react-burgers");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _react = _interopRequireDefault(require("react"));
var _templateObject;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var Toggler = (0, _styledComponents.default)(function (_ref) {
  var active = _ref.active,
    onClick = _ref.onClick,
    className = _ref.className;
  return /*#__PURE__*/_react.default.createElement(_reactBurgers.Slider, {
    onClick: onClick,
    active: active,
    color: "#9090BB",
    lineHeight: 2,
    lineSpacing: 5,
    width: 24,
    padding: 0,
    className: className
  });
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  height: 16px;\n  position: relative;\n  z-index: 9999;\n"])));
exports.Toggler = Toggler;